import './BannerNotfoundHomePhone.css';
import logo from '../../../imgs/logo-eqg-white.svg'
import Homeimg from '../../../imgs/home-img.png'
import { HiOutlineLockClosed } from "react-icons/hi";
import { motion } from "framer-motion";

function BannerNotfoundPhone() {

    return (
        <div className='container'>
            <div className='logo'>
                <motion.div
                     animate={{ x: [10, 40, 0], opacity: 1, scale: 1 }}
                     transition={{
                         duration: 1,
                         delay: 0.3,
                     }}
                     initial={{ opacity: 0, scale: 0.5 }}
                >
                <img alt='logo eu quero grana' src={logo} />
            </motion.div>

            </div>
            <div className='container-top'>
                <div className='imagem'>
                <motion.div
                    animate={{ x: [0, 0], opacity: 1, scale: 1 }}
                    transition={{
                        duration: 1,
                        delay: 0.3,
                    }}
                    initial={{ opacity: 0, scale: 0.5 }}
                >
                    <img alt='servidores públicos' src={Homeimg} />
                </motion.div>
                </div>
                <motion.div
                      animate={{ x: [-50, 10, 0], opacity: 1, scale: 1 }}
                >
                <div className='textos'>
                    <h1>Empréstimo com débito na Conta de Luz </h1>
                    <p>A luz na sua saúde financeira</p>
                </div>
                </motion.div>
            </div>
            <div className='containerfooter'>
            </div>
            <div className='textfooter'>
                <div className='locked'><HiOutlineLockClosed /></div>

                <h6>Você está em um ambiente seguro.</h6>
            </div>

        </div>
    );
}

export default BannerNotfoundPhone;